var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-cover-con clearfix" },
    [
      _c("yxtbiz-upload-image", {
        attrs: {
          "no-crop": "",
          multipe: "",
          list: _vm.list,
          limit: 5,
          "config-key": "ImageConfigKey",
          "module-name": "test_module",
          source: "501",
          size: 2048,
          "function-name": "test_function",
          "oversize-msg": _vm.$t("pc_biz_complain_oversize"),
          "app-code": "cc",
        },
        on: { fileAdded: _vm.fileAdded, fileRemoved: _vm.fileRemoved },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }